var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtCloudWork = function SvgBtCloudWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 23.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#E8E9ED",
    strokeWidth: 0.5,
    rx: 5.625
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5514B4",
    d: "M10.625 7.43a2.72 2.72 0 0 1 2.335 1.315l.195.32.352-.128a2.277 2.277 0 0 1 3.003 2.67l-.09.383.365.146a1.823 1.823 0 0 1-.672 3.52h-7.77a2.284 2.284 0 0 1-.711-4.454l.38-.126-.075-.393a2.732 2.732 0 0 1 2.688-3.253m0-.457a3.19 3.19 0 0 0-3.137 3.795 2.74 2.74 0 0 0 .856 5.345h7.77a2.28 2.28 0 0 0 .84-4.4 2.736 2.736 0 0 0-3.604-3.206 3.19 3.19 0 0 0-2.725-1.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5514B4",
    d: "M12.079 13.823H8.723a.38.38 0 0 1-.377-.377v-.13a1.73 1.73 0 0 1 1.188-1.576l.213-.083.167.425-.212.084a1.3 1.3 0 0 0-.9 1.15v.05H12v-.05a1.3 1.3 0 0 0-.9-1.15l-.212-.084.167-.425.213.083a1.73 1.73 0 0 1 1.189 1.575v.131a.377.377 0 0 1-.378.377"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5514B4",
    d: "M10.401 10.627a.678.678 0 1 1 0 1.356.678.678 0 0 1 0-1.356m0-.457a1.135 1.135 0 1 0 0 2.27 1.135 1.135 0 0 0 0-2.27M12.115 12.825l-.363-.279.14-.18a2 2 0 0 1 .25-.265c.18-.155.387-.279.61-.365l.212-.084.168.425-.213.084a1.7 1.7 0 0 0-.478.286q-.104.089-.187.197zM15.297 13.818H11.8v-.457h3.416v-.05a1.3 1.3 0 0 0-.9-1.15l-.212-.084.168-.425.213.084a1.73 1.73 0 0 1 1.188 1.575v.13a.38.38 0 0 1-.377.377"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5514B4",
    d: "M13.619 10.622a.678.678 0 1 1 0 1.356.678.678 0 0 1 0-1.356m0-.457a1.135 1.135 0 1 0 0 2.27 1.135 1.135 0 0 0 0-2.27"
  }))));
};
export default SvgBtCloudWork;